import React from "react";
import SearchResultsList from "./SearchResultsList";
import {SearchModeProp} from "./SearchResultsPage";

function SearchResultsContainer(componentProps: SearchModeProp) : JSX.Element {
  return(
    <>
      <SearchResultsList locale={componentProps.locale} keywords={componentProps.keywords}/>
    </>
  )
}
export default SearchResultsContainer;
